import { useMutation } from 'react-query';
import { updateCompanySubtypes } from '~/api/admin';
import { CompanySubtypeCode } from '~/types/company';

interface UpdateCompanySubtypesParams {
  id: string;
  subtypeCodes: CompanySubtypeCode[];
}

export const useUpdateCompanySubtypes = (params = {}) => {
  return useMutation({
    mutationFn: async ({ id, subtypeCodes }: UpdateCompanySubtypesParams) =>
      updateCompanySubtypes(id, subtypeCodes),
    ...params
  });
};
